import {
    GET_ORG_OTC_SUCCESS,
    RESET_OTC_STATE,
    SET_ACTIVE_USER_ORG,
    SET_PAGE_INDEX,
    SET_ROW_COUNT
} from '../actions/types';

const INITIAL_STATE = {
    loading: null,
    error: null,
    otcCodes: null,
    otcCode: null,
    otcPage: 0,
    otcRow: 10
};

const alphabetizeByName = codes => {
    if (codes && codes.length > 1) {
        const sortedCodes = codes.sort(function (a, b) {
            if (a.name > b.name) {
                return 1;
            }
            if (a.name < b.name) {
                return -1;
            }
            return 0;
        });
        return sortedCodes;
    } else {
        return codes;
    }
};

const otcReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_ORG_OTC_SUCCESS:
            return {
                ...state,
                otcCodes: alphabetizeByName(action.payload)
            };
        case RESET_OTC_STATE:
            return {
                ...state,
                otcCode: INITIAL_STATE.otcCode,
                loading: INITIAL_STATE.loading,
                error: INITIAL_STATE.error
            };
        case SET_ACTIVE_USER_ORG:
            return {
                ...state,
                otcCodes: alphabetizeByName([]),
                otcPage: INITIAL_STATE.otcPage,
                otcRow: INITIAL_STATE.otcRow
            };
        case SET_PAGE_INDEX:
            return {
                ...state,
                otcPage:
                    action.payload.type === 'otc' ? action.payload.value : state.otcPage
            };
        case SET_ROW_COUNT:
            return {
                ...state,
                otcRow:
                    action.payload.type === 'otc' ? action.payload.value : state.otcRow
            };
        default:
            return state;
    }
};

export default otcReducer;
